@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/spacers';
@import '@helsenorge/designsystem-react/scss/breakpoints';

.icon-display {
  align-items: center;
  background-color: transparent;
  border: none;
  margin-bottom: 0.5rem;

  &--quiz {
    margin-bottom: 2rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin-bottom: 1.5rem;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgb(255 255 255 / 38%) 0%, rgb(255 236 211 / 58%) 42.71%, rgb(255 229 194 / 81%) 89.06%);
    min-width: 8.5rem;
    min-height: 8.5rem;
    box-shadow: 1px 2px 4px #0000003f;
    border-radius: 10rem;
    border: none;
    transition:
      transform 0.5s ease-in-out,
      background-color 0.5s ease-in-out,
      outline 0.5s ease-in-out;

    @media (max-width: map.get($grid-breakpoints, md)) {
      min-width: 60px;
      min-height: 60px;
    }

    svg {
      transition: transform 0.5s ease-in-out;
    }
  }

  &__text {
    position: relative;
    padding: 0;
    margin: 0;
    font-family: Avenir, Montserrat, Poppins, serif;
    font-weight: 500;
    font-size: 30px;
    line-height: 2rem;
    padding-left: 2rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 24px;
      padding-left: 1rem;
      text-align: left;
    }
  }

  color: #fff;
  display: inline-flex;
  justify-content: left;
  width: 100%;

  &--svarside {
    color: #ffdbb3;
    font-weight: 500;
    font-size: 24px;
    line-height: 25px;
    letter-spacing: 0;
    text-align: left;
    width: 100%;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 16px;
    }
  }
}
